import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../../../firebase";

// App version info lives in a single Firestore doc: config/appVersion.
const CONFIG_COLLECTION = "config";
const CONFIG_DOC = "appVersion";

export const DEFAULT_APP_VERSION_CONFIG = {
  mobile: {
    latestVersion: "",
    message: "",
    androidUrl: "",
    iosUrl: "",
  },
  webApp: {
    latestVersion: "",
  },
  admin: {
    latestVersion: "",
  },
};

export const getAppVersionConfig = async () => {
  try {
    const docRef = doc(db, CONFIG_COLLECTION, CONFIG_DOC);
    const snap = await getDoc(docRef);
    const data = snap.exists() ? snap.data() : {};
    // Merge over defaults so every field is present for the UI.
    return {
      ...data,
      mobile: { ...DEFAULT_APP_VERSION_CONFIG.mobile, ...(data.mobile || {}) },
      webApp: { ...DEFAULT_APP_VERSION_CONFIG.webApp, ...(data.webApp || {}) },
      admin: { ...DEFAULT_APP_VERSION_CONFIG.admin, ...(data.admin || {}) },
    };
  } catch (error) {
    console.log("Error fetching appVersion config:", error.message);
    return { ...DEFAULT_APP_VERSION_CONFIG };
  }
};

// Writes with merge so it creates the doc if missing and never clobbers
// unrelated fields.
export const updateAppVersionConfig = async (docData) => {
  const docRef = doc(db, CONFIG_COLLECTION, CONFIG_DOC);
  return await setDoc(docRef, docData, { merge: true });
};
